import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; //  Import PropTypes
import * as Icon from 'react-feather';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const SuperUsersMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, activeTab,data,user}) => {
  
  const { t } = useTranslation();

  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
            <div key={index} className="bg-white p-4 rounded-bottom mb-5 w-100">
                 <div className="d-flex justify-content-end mb-2 py-2 rounded">
                   {/* Center - profile */}
                   <div className="flex-grow-1 text-center">
                     <Link
                       to="#"
                       className="avatar avatar-md mb-2"
                       style={{ width: 100, height: 100 }}
                     >
                       {item.imgprofile ? (
                         <img
                           className="avatar-img rounded-circle"
                           src={item.imgprofile}
                           width="200"
                           alt="User"
                         />
                       ) : (
                         <i className="fas fa-briefcase text-muted position-absolute top-50 start-50 translate-middle" style={{ fontSize: "27px" }}></i>
                       )}
                     </Link>
                   </div>
           
                   {/* Right - badge */}
                   <div>
                    {item.verified ?  <span className="badge badge-pill bg-success-light">Verified</span> :
                        <span className="badge badge-pill bg-warning text-black">Not Verified</span>}
                   </div>
                 </div>
           
                 {/* Header Section */}
                 <div className='d-flex justify-content-between align-items-start mb-4'>
                   <div className='flex-grow-1'>
                     <h5 className="fw-bold text-dark mb-1 lh-base">{item.name}</h5>
                   </div>
                   <div className='ms-3'>
                     <span className='badge bg-light text-muted px-3 py-2 rounded-pill fw-medium' style={{fontSize: '0.875rem'}}>{item.code}</span>
                   </div>
                 </div>

                 {/* Company Information Section */}
                 <div className='mb-4'>
                   <h6 className='fw-bold text-dark mb-3 text-uppercase' style={{letterSpacing: '0.5px', fontSize: '0.875rem'}}>
                     Company Information
                   </h6>
                   <div className='profile-details'>
                     <div className='d-flex align-items-start py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}} 
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                       <div style={{minWidth: '120px', flexShrink: 0}}>
                         <span className='text-dark fw-medium'>Info Admin</span>
                       </div>
                       <div style={{flex: 1, marginLeft: '20px'}}>
                         <InfoAdmin user={user} record={item} activeTab={activeTab}/>
                       </div>
                     </div>
                     
                     <div className='d-flex align-items-center py-2 px-2' style={{transition: 'all 0.2s ease'}}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                       <div style={{minWidth: '120px', flexShrink: 0}}>
                         <span className='text-dark fw-medium'>Created At</span>
                       </div>
                       <div style={{flex: 1, marginLeft: '20px'}}>
                         <span className='text-dark fw-bold'>{item.created_at}</span>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
           
        ))
    ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
            <p>No Data</p>
        </div>
    )}

    {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  )
}
const InfoAdmin = ({user,record,activeTab})=>{
    //const adminUser = user.type === "agency"? record?.agency_users?.find(user => user.is_admin_agency === true):record?.supplier_users?.find(user => user.is_admin_supplier === true)

    const adminUser = activeTab === "agency"? record?.agency_users?.find(user => user.is_admin_agency === true):record?.supplier_users?.find(user => user.is_admin_supplier === true)
   const adminName = adminUser ? adminUser.name : "";
                return (
                 <div className='text-dark'>
                   <div className='mb-2'>
                     <span className='fw-bold'>{adminName}</span>
                   </div>
                   <div className='small text-dark mb-1'>
                     <strong>Contact Phone:</strong> {record.phone}
                   </div>
                   <div className='small text-dark'>
                     <strong>Admin Email:</strong> {record.admin_email}
                   </div>
                 </div>
                )
}

InfoAdmin.propTypes = {
  user: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  activeTab: PropTypes.string.isRequired,
};

SuperUsersMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  user: PropTypes.object.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default SuperUsersMobile